import { render, staticRenderFns } from "./preWorship.vue?vue&type=template&id=2c39f60d&scoped=true"
import script from "./preWorship.vue?vue&type=script&lang=js"
export * from "./preWorship.vue?vue&type=script&lang=js"
import style0 from "./preWorship.vue?vue&type=style&index=0&id=2c39f60d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c39f60d",
  null
  
)

export default component.exports